'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          secondary = _props.secondary,
          opinion = _props.opinion,
          basic = _props.basic,
          left = _props.left,
          right = _props.right,
          floated = _props.floated,
          labeled = _props.labeled,
          icon = _props.icon,
          loading = _props.loading,
          circular = _props.circular,
          fluid = _props.fluid,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['secondary', 'opinion', 'basic', 'left', 'right', 'floated', 'labeled', 'icon', 'loading', 'circular', 'fluid', 'className']);

      var cx = (0, _classnames2.default)({
        secondary: secondary,
        opinion: opinion,
        basic: basic,
        left: left,
        right: right,
        floated: floated,
        labeled: labeled,
        icon: icon,
        loading: loading,
        circular: circular,
        fluid: fluid
      }, 'button', className);

      return _react2.default.createElement(_Box2.default, _extends({
        wrapper: labeled && !icon ? 'div' : 'button',
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Button;
}(_react.Component);

Button.displayName = 'Button';

Button.propTypes = {
  secondary: _propTypes2.default.bool,
  opinion: _propTypes2.default.bool,
  basic: _propTypes2.default.bool,
  left: _propTypes2.default.bool,
  right: _propTypes2.default.bool,
  floated: _propTypes2.default.bool,
  labeled: _propTypes2.default.bool,
  icon: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  circular: _propTypes2.default.bool,
  fluid: _propTypes2.default.bool
};

exports.default = Button;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6WyJCdXR0b24iLCJwcm9wcyIsInNlY29uZGFyeSIsIm9waW5pb24iLCJiYXNpYyIsImxlZnQiLCJyaWdodCIsImZsb2F0ZWQiLCJsYWJlbGVkIiwiaWNvbiIsImxvYWRpbmciLCJjaXJjdWxhciIsImZsdWlkIiwiY2xhc3NOYW1lIiwicmVzdCIsImN4IiwiZGlzcGxheU5hbWUiLCJwcm9wVHlwZXMiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7O0lBRU1BLE07Ozs7Ozs7Ozs7OzZCQUNLO0FBQUEsbUJBZUgsS0FBS0MsS0FmRjtBQUFBLFVBRUxDLFNBRkssVUFFTEEsU0FGSztBQUFBLFVBR0xDLE9BSEssVUFHTEEsT0FISztBQUFBLFVBSUxDLEtBSkssVUFJTEEsS0FKSztBQUFBLFVBS0xDLElBTEssVUFLTEEsSUFMSztBQUFBLFVBTUxDLEtBTkssVUFNTEEsS0FOSztBQUFBLFVBT0xDLE9BUEssVUFPTEEsT0FQSztBQUFBLFVBUUxDLE9BUkssVUFRTEEsT0FSSztBQUFBLFVBU0xDLElBVEssVUFTTEEsSUFUSztBQUFBLFVBVUxDLE9BVkssVUFVTEEsT0FWSztBQUFBLFVBV0xDLFFBWEssVUFXTEEsUUFYSztBQUFBLFVBWUxDLEtBWkssVUFZTEEsS0FaSztBQUFBLFVBYUxDLFNBYkssVUFhTEEsU0FiSztBQUFBLFVBY0ZDLElBZEU7O0FBZ0JQLFVBQUlDLEtBQUssMEJBQ1A7QUFDRWIsNEJBREY7QUFFRUMsd0JBRkY7QUFHRUMsb0JBSEY7QUFJRUMsa0JBSkY7QUFLRUMsb0JBTEY7QUFNRUMsd0JBTkY7QUFPRUMsd0JBUEY7QUFRRUMsa0JBUkY7QUFTRUMsd0JBVEY7QUFVRUMsMEJBVkY7QUFXRUM7QUFYRixPQURPLEVBY1AsUUFkTyxFQWVQQyxTQWZPLENBQVQ7O0FBa0JBLGFBQ0U7QUFDRSxpQkFBU0wsV0FBVyxDQUFDQyxJQUFaLEdBQW1CLEtBQW5CLEdBQTJCLFFBRHRDO0FBRUUsZ0JBRkY7QUFHRSxtQkFBV007QUFIYixTQUlNRCxJQUpOLEVBREY7QUFRRDs7Ozs7O0FBR0hkLE9BQU9nQixXQUFQLEdBQXFCLFFBQXJCOztBQUVBaEIsT0FBT2lCLFNBQVAsR0FBbUI7QUFDakJmLGFBQVcsb0JBQVVnQixJQURKO0FBRWpCZixXQUFTLG9CQUFVZSxJQUZGO0FBR2pCZCxTQUFPLG9CQUFVYyxJQUhBO0FBSWpCYixRQUFNLG9CQUFVYSxJQUpDO0FBS2pCWixTQUFPLG9CQUFVWSxJQUxBO0FBTWpCWCxXQUFTLG9CQUFVVyxJQU5GO0FBT2pCVixXQUFTLG9CQUFVVSxJQVBGO0FBUWpCVCxRQUFNLG9CQUFVUyxJQVJDO0FBU2pCUixXQUFTLG9CQUFVUSxJQVRGO0FBVWpCUCxZQUFVLG9CQUFVTyxJQVZIO0FBV2pCTixTQUFPLG9CQUFVTTtBQVhBLENBQW5COztrQkFjZWxCLE0iLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6IkQ6XFxQcm9qZWN0c1xccmVhY3QtdG9jYXNcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/Button.js
// module id = 562
// module chunks = 0